import mixins from 'synergycms_core/src/less/mixins';

export default {
  closeButton: {},
  loadingModalcontent: {},
  defaultStyle: {
    backgroundColor: '#fff',
    '&:lang(ar)': {
      direction: 'rtl',
      textAlign: 'right'
    }
  },
  loadingModalStyle: {
    ...mixins.transition('.5s'),
    position: 'fixed',
    height: '100%',
    width: '100%',
    top: '0',
    float: 'left',
    background: 'rgb(0, 17, 27)',
    zIndex: '99999',
    display: 'table',
    '& $loadingModalcontent': {
      width: '100%',
      height: '100%',
      position: 'absolute',
      '& $closeButton': {
        display: 'none'
      }
    },
    '&:lang(ar)': {
      float: 'right'
    }
  }
};
